(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multiple-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".video-wrapperr").forEach(function(wrapper) {
      const poster = wrapper.querySelector(".video-poster");
      const iframe = wrapper.querySelector("iframe");
      if (poster && iframe) {
        poster.addEventListener("click", function() {
          iframe.src = iframe.dataset.url;
          poster.style.display = "none";
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
